import { jsx, jsxs } from 'react/jsx-runtime';
import { cn } from '../../../lib/utils.js';

const RoundListItem = ({
  label,
  description,
  className
}) => {
  return /* @__PURE__ */ jsx(
    "li",
    {
      className: cn(
        "flex items-center gap-2 border border-basic-04 rounded-[12px] p-4 bg-base-white",
        className
      ),
      children: /* @__PURE__ */ jsxs("dl", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ jsx("dt", { className: "body-lg text-primary-02 font-weight-medium", children: label }),
        /* @__PURE__ */ jsx("dd", { className: "body-md text-basic-04", children: description })
      ] })
    }
  );
};

export { RoundListItem };
